import Button from '@primitives/Button/Button';
import RefreshIcon from '@icons/RefreshIcon/RefreshIcon';
import Typography from '@primitives/Typography/Typography';
import styles from './index.module.scss';
import { LONGHORN_URL } from '@cp/src/constants/Global';

const handleOnClick = () => {
  window.location.href = LONGHORN_URL;
};

function Footer() {
  return (
    <div className={styles.footer}>
      <Button
        className={styles.RefreshButton}
        color="var(--navi-color-blue-dot)"
        startAdornment={<RefreshIcon color="var(--navi-color-blue-dot)" />}
        variant="secondary"
        onClick={handleOnClick}
      >
        <Typography as="span" variant="p3" color="var(--navi-color-blue-dot)">
          Refresh
        </Typography>
      </Button>
    </div>
  );
}

export default Footer;
